import {State} from '../reducers';
import {Article, Label} from '../reducers/article';

export const articlesSelector = (state: State): Article[] => {
  return state.articles.data.map(mapVeloArticle);
};

const mapCorvidToVeloLabel = (label: Label): Label => {
  return label.path === '/corvid' ? {name: 'Velo', path: '/velo'} : label;
};

const mapVeloArticle = (article: Article): Article => {
  const clone: Article = JSON.parse(JSON.stringify(article));
  clone.labels = clone.labels.map(mapCorvidToVeloLabel);
  return clone;
};
